// src/pages/Center Admin/GrowthChartEntry.tsx
import React, { useState, useEffect } from "react";
import "../../center admin css/GrowthChartScreen.css";
import GrowthChartActivePatientCard from "../../components/Center Admin/Reuse/GrowthChartActivePatientCard";
import GrowthChartForm from "../../components/Center Admin/forms/GrowthChartEntry";
import CenterAppointmentsQueue from "../../components/Center Admin/layout/CenterAppointmentsQueue"; // ✅ ADD
import "../../center admin css/centerAdmin.css";

type Patient = {
  id?: string;
  emrId?: string;
  name?: string;
  genderShort?: "M" | "F";
  ageYears?: number;
  avatarUrl?: string;
  sessionId?: string;
};

const GrowthChartEntry: React.FC = () => {
  const [patient, setPatient] = useState<Patient | null>(null);
  const [activeId, setActiveId] = useState<string | undefined>();

  const handleSelect = (id: string, p?: Patient) => {
    setActiveId(id);
    if (p) setPatient(p);
  };

  const centerId =
    sessionStorage.getItem("centerId") ||
    localStorage.getItem("centerId") ||
    "";

  // ✅ Function to load patient from sessionStorage
  const loadPatient = () => {
    try {
      // const stored = sessionStorage.getItem("selectedPatient");
      const storageKey = "selectedPatient_GROWTH_CHART_Q";
      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        const parsed: Patient = JSON.parse(stored);
        setPatient((prev: Patient | null) =>
          JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev,
        );
      } else {
        setPatient(null);
      }
    } catch {
      setPatient(null);
    }
  };

  // ✅ Load initially
  useEffect(() => {
    loadPatient();
  }, []);

  // ✅ Listen for both session updates and custom event triggers
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      
      if (e.key === "selectedPatient_GROWTH_CHART_Q") loadPatient();
    };

    const handleCustomUpdate = () => {
      loadPatient();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("patientUpdated", handleCustomUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("patientUpdated", handleCustomUpdate);
    };
  }, []);

  return (
    <div className="lab-reports-page" style={{ display: "flex" }}>
      {/* ✅ LEFT SIDE QUEUE */}
      <CenterAppointmentsQueue
        centerId={centerId}
        queueApi="GROWTH_CHART_Q" // ✅ IMPORTANT
        activeId={patient?.id} // ✅ ADD THIS LINE
        onSelect={handleSelect}
      />

      {/* ✅ RIGHT SIDE CONTENT */}
      <div style={{ flex: 1 }}>
        {/* Active Patient */}
        <GrowthChartActivePatientCard patient={patient || undefined} />

        {/* Growth Chart Form */}
        <div className="lab-reports-content">
          {patient?.emrId && <GrowthChartForm emrId={patient.emrId} />}
        </div>
      </div>
    </div>
  );
};

export default GrowthChartEntry;
